module.exports = __webpack_public_path__ + "img/facebook.77cb682a.svg";